module.exports = __webpack_public_path__ + "img/kinmen_main_pc.3ea6cdac.png";